<template>
    <div :id="modalID" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="min-width: 650px">
            <div class="modal-content">
                <div class="modal-header d-flex align-items-center">
                    <div style="font-size: 15px; font-weight: 500; line-height: 21px; color: #00203f">{{ $t('views.inventory.modals.savedFilters.title') }}</div>
                    <button type="button" class="close-button btn btn-link" @click="closeModal"><i class="bi bi-x-lg" style="color: #677788"></i></button>
                </div>
                <div class="modal-body">
                    <table class="table modal-table">
                        <thead class="thead-light">
                            <tr>
                                <th>{{ $t('views.inventory.modals.savedFilters.filterName.title') }}</th>
                                <th>{{ $t('views.inventory.modals.savedFilters.actions.title') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="item in filters">
                                <tr v-if="![-1, -2, -3].includes(item.id)" :key="item.id">
                                    <td class="filterName">
                                        <input v-if="item.editable" class="form-control" v-model="item.filter_name" />
                                        <template v-else>{{ item.filter_name }}</template>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center justify-content-end" style="gap: 5px">
                                            <template v-if="item.editable">
                                                <button class="btn secondary-primary btn-sm" @click=";(item.editable = false), (item.filter_name = item.filter_name_clone)">{{ $t('views.inventory.modals.savedFilters.cancel') }}</button>
                                                <button class="btn btn-primary btn-sm" @click="changeFilterName(item.id, item.filter_name)">{{ $t('views.inventory.modals.savedFilters.save') }}</button>
                                            </template>
                                            <template v-else>
                                                <button class="btn btn-outline-secondary btn-sm" @click="deleteFilterById(item.id)"><i class="fa-solid fa-trash"></i></button>
                                                <button class="btn secondary-primary btn-sm" @click="item.editable = true"><i class="fa-solid fa-edit"></i></button>
                                                <button class="btn btn-primary btn-sm" @click="getFilterCard(item.id)">{{ $t('common.filter') }}</button>
                                            </template>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { Modal } from 'bootstrap'

export default {
    name: 'SavedFilters',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalID: 'SavedFilters-' + crypto.randomUUID(),
            modalInstance: null,
        }
    },
    computed: {
        ...mapState('inventory', ['filters']),
    },
    methods: {
        ...mapActions('inventory', ['deleteFilter', 'updateFilter', 'getInventoryList', 'getFilter']),
        ...mapMutations('inventory', ['SET_FILTER_PARAMS', 'SET_FILTERS', 'SET_SELECTED_FILTER_CARD']),
        closeModal() {
            this.SET_FILTERS(this.filters.map((item) => ({ ...item, editable: false })))
            this.modalInstance.hide()
            this.$emit('update:modelValue', false)
        },
        changeFilterName(id, name) {
            this.updateFilter({ id, payload: { filter_name: name } })
        },
        deleteFilterById(id) {
            if (confirm(this.$t('views.inventory.modals.savedFilters.deleteConfirmation', { filter_name: this.filters.find((item) => item.id === id).filter_name }))) {
                this.deleteFilter(id)
            }
        },
        getFilterCard(id) {
            this.SET_FILTER_PARAMS({ key: 'page', value: 1 })
            this.SET_FILTER_PARAMS({ key: 'filter_id', value: id })
            if ([-1, -2, -3].includes(id)) {
                this.SET_SELECTED_FILTER_CARD({ id })
            } else {
                this.getFilter(id)
            }
            this.getInventoryList()
            this.closeModal()
        },
    },
    watch: {
        modelValue: function (data) {
            if (data) {
                const modalEl = document.getElementById(this.modalID)
                this.modalInstance = new Modal(modalEl, { backdrop: true })
                this.modalInstance.show()
                modalEl.addEventListener('hidden.bs.modal', () => {
                    this.closeModal()
                })
            } else {
                this.closeModal()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
[id^='SavedFilters-'] {
    .close-button {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &:hover {
            background-color: #f8fafd;
        }
    }
}
.modal-table {
    margin-bottom: 0 !important;

    tbody {
        tr {
            border-bottom: 1px solid #e7eaf3b2;

            td {
                height: 67px;
                vertical-align: middle;

                &:first-child {
                    border-right: none;
                }
            }
        }
    }

    .secondary-primary {
        color: #fff;
        background-color: var(--bs-gray-700);

        &:hover {
            background-color: var(--fba-primary);
        }
    }

    .filterName {
        min-width: 375px;
        max-width: 375px;
        height: 67.5px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}
</style>
